import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FlowToolsPageComponent } from './pages/flow-tools-page/flow-tools-page.component';

const routes: Routes = [
  {
    path: 'list',
    component: FlowToolsPageComponent,
    data: {
      firstBreadcrumb: {
        title: 'Con-Héctor',
        icon: '../../../assets/img/ConHector/Personaje_acciones/icon.png',
        url: '/',
      },
      title: 'Simuladores de Flows',
      url: 'flow-tools/list',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlowToolsRoutingModule {}
